<template>
  <div>
    <Projects />
  </div>
</template>

<script>
import Projects from "@/components/Projects/index.vue";
export default {
  components: {
    Projects,
  },
};
</script>

<style></style>
